module.exports = "/packs/she-creators-guide-image-8a154234b91e95eff1257026b19c8a46.png";